import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Split = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Split' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,22 L23,22 L23,2 L1,2 L1,22 Z M12,2 L12,22 L12,2 Z' />
  </StyledIcon>
);
